export default "__VITE_ASSET__kkIAuvz0__"